import { Feature } from "./feature";

export class Service {

    id: string = '';
    name: string = '';
    price: string = '';
    annualPrice: string = '';
    priceType: string = '';
    status: string = '';
    required: number = 0;
    features: Feature[] = [];
    /** Custom commission rate (e.g. 0.05 = 5%) when present on the plan */
    customFeeRate?: number | null;
    /** Fixed subscription length in months when present */
    monthCount?: number | null;
    /** Billing recurrence in months (e.g. 6, 12, 24) */
    recurrency?: number | null;
    visible?: boolean | number;
    createdAt?: string;

    constructor(raw?: Partial<Service> | Service) {
        if (raw) {
            this.id = raw.id ?? '';
            this.name = raw.name ?? '';
            this.price = raw.price ?? '';
            this.priceType = raw.priceType ?? '';
            this.annualPrice = raw.annualPrice ?? '';
            this.status = raw.status ?? '';
            this.required = raw.required ?? 0;
            this.features = Array.isArray(raw.features) ? raw.features : [];
            this.customFeeRate = raw.customFeeRate ?? null;
            this.monthCount = raw.monthCount ?? null;
            this.recurrency = raw.recurrency != null ? Number(raw.recurrency) : null;
            this.visible = raw.visible ?? true;
            this.createdAt = raw.createdAt;
        }
    }
}